import {Component, ElementRef, Input, OnInit} from '@angular/core';

@Component({
  selector: 'as-input-counter',
  templateUrl: './input-counter.component.html',
  styleUrls: ['./input-counter.component.scss']
})
export class InputCounterComponent implements OnInit {

  @Input() min: number;
  @Input() prop



  constructor() {
  }

  ngOnInit() {
  }

}

